import {HttpEvent, HttpHandler, HttpInterceptor, HttpRequest} from '@angular/common/http';
import {Injectable} from '@angular/core';
import {Observable} from 'rxjs';
import {FusionAuthService} from '../services/fusion-auth';

@Injectable()
export class HttpHeaderInterceptor implements HttpInterceptor {
  constructor(private fusionAuthService: FusionAuthService) {
  }

  public intercept(request: HttpRequest<any>, next: HttpHandler): Observable<HttpEvent<any>> {
    const jwtToken = this.fusionAuthService.getToken();
    let headers = {};

    if (request.headers.has('enctype')) {
      for (const key of request.headers.keys()) {
        headers = {
          ...headers,
          [key]: request.headers.get(key),
        }
      }
    } else {
      headers = {
        'content-type': 'application/json',
      };
    }

    if (jwtToken !== null && jwtToken !== undefined && jwtToken !== '') {
      headers = {...headers, authorization: `JWT ${jwtToken}`} as any
    }

    request = request.clone({
      setHeaders: headers,
      withCredentials: false,
    });

    return next.handle(request);
  }
}
